<template>
  <div class="search-page">
    <section class="search-root">
      <!-- <header>
        <search-tabs
          v-if="query"
          :tabs="tabs"
          :selected-tab="activeTabIndex"
          @tab-change="tab => (selectedTab = tab)"
        />
      </header> -->
      <div class="search-results">
        <div v-if="showResultsSection">
          <search-result-contacts-list
            v-if="filterContacts"
            :is-fetching="uiFlags.contact.isFetching"
            :contacts="contacts"
            :query="query"
            :show-title="isSelectedTabAll"
            @start-conversation="startConversationWithContact"
          />

          <search-result-messages-list
            v-if="filterMessages && isPageDefault"
            :is-fetching="uiFlags.message.isFetching"
            :messages="messages"
            :query="query"
            :show-title="isSelectedTabAll"
          />

          <search-result-conversations-list
            v-if="filterConversations && isPageDefault"
            :is-fetching="uiFlags.conversation.isFetching"
            :conversations="conversations"
            :query="query"
            :show-title="isSelectedTabAll"
          />

          <search-result-tickets-list
            v-if="filterTickets && isPageDefault"
            :is-fetching="uiFlags.ticket.isFetching"
            :tickets="tickets"
            :query="query"
            :show-title="isSelectedTabAll"
          />
        </div>
        <div v-else-if="showEmptySearchResults" class="empty">
          <fluent-icon icon="info" size="16px" class="icon" />
          <p class="empty-state__text">
            {{ $t('SEARCH.EMPTY_STATE_FULL', { query }) }}
          </p>
          <p v-if="showPhoneError" class="phone-error-message">
            {{ $t('SEARCH.PHONE_ERROR_MESSAGE') }}
          </p>
          <button 
            class="button nice success start-conversation-btn"
            @click="startConversationWithNumber"
          >
            <fluent-icon icon="add-circle" size="16px" />
            {{ $t('SEARCH.START_CONVERSATION_WITH', { number: query }) }}
          </button>
        </div>
        <div v-else class="empty text-center">
          <p class="text-center margin-bottom-0">
            <fluent-icon icon="search" size="24px" class="icon" />
          </p>
          <p class="empty-state__text">
            {{ emptyStateDefault }}
          </p>
        </div>
      </div>
    </section>
    
    <!-- Modal para iniciar conversa -->
    <woot-modal
      v-if="showConversationModal && newContact"
      :show.sync="showConversationModal"
      :on-close="onCancelConversation"
      size="medium"
    >
      <conversation-form
        :contact="newContact"
        :on-submit="onConversationSubmit"
        @cancel="onCancelConversation"
        @success="onCancelConversation"
      />
    </woot-modal>
  </div>
</template>

<script>
import SearchTabs from './SearchTabs.vue';
import SearchResultConversationsList from './SearchResultConversationsList.vue';
import SearchResultMessagesList from './SearchResultMessagesList.vue';
import SearchResultContactsList from './SearchResultContactsList.vue';
import SearchResultTicketsList from './SearchResultTicketsList.vue';
import ConversationForm from 'dashboard/routes/dashboard/conversation/contact/ConversationForm';

import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';
import { CONVERSATION_EVENTS } from '../../../helper/AnalyticsHelper/events';
export default {
  components: {
    SearchTabs,
    SearchResultContactsList,
    SearchResultConversationsList,
    SearchResultMessagesList,
    SearchResultTicketsList,
    ConversationForm,
  },
  mixins: [clickaway],
  data() {
    return {
      selectedTab: 'all',
      query: '',
      isPageDefault: true,
      emptyStateDefault: this.$t('SEARCH.EMPTY_STATE_DEFAULT'),
      showConversationModal: false,
      newContact: null,
      showPhoneError: false,
    };
  },

  computed: {
    ...mapGetters({
      contactRecords: 'conversationSearch/getContactRecords',
      conversationRecords: 'conversationSearch/getConversationRecords',
      messageRecords: 'conversationSearch/getMessageRecords',
      ticketRecords: 'conversationSearch/getTicketRecords',
      uiFlags: 'conversationSearch/getUIFlags',
      queryConversation: 'conversationSearch/getQueryConversation',
    }),
    contacts() {
      return this.contactRecords
        ?.map(contact => ({
          ...contact,
          type: 'contact',
        }))
        .filter(contact => !contact?.phone_number?.includes('@g.us'));
    },
    conversations() {
      return this.conversationRecords.map(conversation => ({
        ...conversation,
        type: 'conversation',
      }));
    },
    messages() {
      return this.messageRecords.map(message => ({
        ...message,
        type: 'message',
      }));
    },
    tickets() {
      return this.ticketRecords.map(ticket => ({
        ...ticket,
        type: 'ticket',
      }));
    },
    all() {
      return [
        ...this.contacts,
        ...this.conversations,
        ...this.messages,
        ...this.tickets,
      ];
    },
    filterContacts() {
      return this.selectedTab === 'contacts' || this.isSelectedTabAll;
    },
    filterConversations() {
      return this.selectedTab === 'conversations' || this.isSelectedTabAll;
    },
    filterMessages() {
      return this.selectedTab === 'messages' || this.isSelectedTabAll;
    },
    filterTickets() {
      return this.selectedTab === 'tickets' || this.isSelectedTabAll;
    },
    totalSearchResultsCount() {
      return (
        this.contacts.length +
        this.conversations.length +
        this.messages.length +
        this.tickets.length
      );
    },
    tabs() {
      return [
        {
          key: 'all',
          name: this.$t('SEARCH.TABS.ALL'),
          count: this.totalSearchResultsCount,
        },
        {
          key: 'contacts',
          name: this.$t('SEARCH.TABS.CONTACTS'),
          count: this.contacts.length,
        },
        {
          key: 'conversations',
          name: this.$t('SEARCH.TABS.CONVERSATIONS'),
          count: this.conversations.length,
        },
        {
          key: 'messages',
          name: this.$t('SEARCH.TABS.MESSAGES'),
          count: this.messages.length,
        },
        {
          key: 'tickets',
          name: this.$t('SEARCH.TABS.TICKETS'),
          count: this.tickets.length,
        },
      ];
    },
    activeTabIndex() {
      const index = this.tabs.findIndex(tab => tab.key === this.selectedTab);
      return index >= 0 ? index : 0;
    },
    showEmptySearchResults() {
      return (
        this.totalSearchResultsCount === 0 &&
        this.uiFlags.isSearchCompleted &&
        !this.uiFlags.isFetching &&
        this.query
      );
    },
    showResultsSection() {
      return (
        (this.uiFlags.isSearchCompleted &&
          this.totalSearchResultsCount !== 0) ||
        this.uiFlags.isFetching
      );
    },
    isSelectedTabAll() {
      return this.selectedTab === 'all';
    },
    isValidPhoneNumber() {
      // Verifica se a query parece ser um número de telefone
      // Aceita números com ou sem formatação (+, espaços, traços, parênteses)
      const cleanedQuery = this.query.replace(/[\s\-()]/g, '');
      
      // Se começar com +, precisa ter pelo menos 12 dígitos (+55 + 10 dígitos)
      if (cleanedQuery.startsWith('+')) {
        return /^\+[0-9]{12,15}$/.test(cleanedQuery);
      }
      
      // Se não começar com +, precisa ter pelo menos 10 dígitos (DDD + número)
      return /^[0-9]{10,13}$/.test(cleanedQuery);
    },
  },
  watch: {
    queryConversation(newValue) {
      if (newValue && newValue !== 'close-modal') {
        this.query = newValue;
      } else if (newValue === '' || newValue === 'close-modal') {
        this.query = '';
      }
    },
    $route: {
      handler(newValue) {
        if (newValue.path.includes('contacts')) {
          this.emptyStateDefault = this.$t(
            'SEARCH.EMPTY_STATE_DEFAULT_CONTACT'
          );
        } else {
          this.emptyStateDefault = this.$t('SEARCH.EMPTY_STATE_DEFAULT');
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.query = '';
    this.$store.dispatch('conversationSearch/clearSearchResults');
  },
  mounted() {
    if (this.$route.path.includes('contacts')) {
      this.isPageDefault = false;
    }

    if (this.queryConversation && this.queryConversation !== 'close-modal') {
      this.query = this.queryConversation;
    }

    this.$store.dispatch('conversationSearch/clearSearchResults');
  },
  methods: {
    onSearch(q) {
      this.selectedTab = 'all';
      this.query = q;
      if (!q) {
        this.$store.dispatch('conversationSearch/clearSearchResults');
        return;
      }
      this.$track(CONVERSATION_EVENTS.SEARCH_CONVERSATION);
      this.$store.dispatch('conversationSearch/fullSearch', { q });
    },
    onBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'home' });
      }
    },
    async startConversationWithNumber() {
      let cleanedNumber = this.query.replace(/[\s\-()]/g, '');
      
      // Validar se tem pelo menos 10 dígitos
      if (!cleanedNumber.startsWith('+') && cleanedNumber.length < 10) {
        this.showPhoneError = true;
        return;
      }
      
      if (cleanedNumber.startsWith('+') && cleanedNumber.length < 12) {
        this.showPhoneError = true;
        return;
      }
      
      this.showPhoneError = false;
      
      if (!cleanedNumber.startsWith('+') && !cleanedNumber.startsWith('55')) {
        cleanedNumber = `+55${cleanedNumber}`;
      } else if (cleanedNumber.startsWith('55') && !cleanedNumber.startsWith('+')) {
        cleanedNumber = `+${cleanedNumber}`;
      }
      
      try {
        const contactData = {
          name: `Contato ${cleanedNumber}`,
          phone_number: cleanedNumber,
        };
        
        await this.$store.dispatch('contacts/create', contactData);
        
        await this.$nextTick();
        
        const allContacts = this.$store.getters['contacts/getContacts'];
        const createdContact = allContacts.find(c => c && c.phone_number === cleanedNumber);
        
        if (createdContact) {
          await this.$store.dispatch('contacts/fetchContactableInbox', createdContact.id);
          
          await new Promise(resolve => setTimeout(resolve, 500));
          
          const updatedContact = this.$store.getters['contacts/getContact'](createdContact.id);
          
          this.newContact = updatedContact;
          this.showConversationModal = true;
        }
      } catch (error) {
        console.error('Error create contact:', error);
      }
    },
    onCancelConversation() {
      this.showConversationModal = false;
      this.newContact = null;
      this.$emit('closeModal');
    },
    async onConversationSubmit(conversationPayload) {
      try {
        const response = await this.$store.dispatch(
          'contactConversations/create',
          conversationPayload
        );
        this.showConversationModal = false;
        this.newContact = null;
        this.$emit('closeModal');
        return response;
      } catch (error) {
        throw error;
      }
    },
    async startConversationWithContact(contactId) {
      try {
        await this.$store.dispatch('contacts/show', { id: contactId });
        await this.$store.dispatch('contacts/fetchContactableInbox', contactId);
        await new Promise(resolve => setTimeout(resolve, 500));
        
        const contact = this.$store.getters['contacts/getContact'](contactId);
        
        if (contact) {
          this.newContact = contact;
          this.showConversationModal = true;
        }
      } catch (error) {
        console.error('Error loading contact:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-page {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.page-header {
  display: flex;
  padding: var(--space-normal);
}
.search-root {
  margin: 0 auto;
  max-width: 72rem;
  min-height: 32rem;
  width: 100%;
  height: 100%;
  padding: var(--space-normal);
  display: flex;
  position: relative;
  flex-direction: column;
  background: white;
  margin-top: var(--space-medium);

  .search-results {
    flex-grow: 1;
    height: 100%;
    overflow-y: auto;
    padding: 0 var(--space-small);
  }
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-medium) var(--space-normal);
  border-radius: var(--border-radius-medium);
  margin-top: var(--space-large);
  .icon {
    color: var(--s-500);
  }
  .empty-state__text {
    text-align: center;
    color: var(--s-500);
    margin: var(--space-small);
  }
}

.start-conversation-btn {
  margin-top: var(--space-normal);
  display: flex;
  align-items: center;
  gap: var(--space-small);
}

.phone-error-message {
  color: var(--r-500);
  font-size: var(--font-size-small);
  margin-top: var(--space-small);
  font-weight: 500;
}
</style>
